import { buildFreeDrive } from './freeDrive';
import { buildRace } from './race';
import type { Scenario } from './types';

/** Choix du jeu réel : mode (libre/course) + circuit + véhicule. */
export interface LiveChoice {
  mode: string;
  track: string;
  vehicle: string;
}

/** Construit le scénario du jeu réel selon le mode choisi. */
export function buildLiveScenario(c: LiveChoice): Scenario {
  return c.mode === 'race' ? buildRace(c.track, c.vehicle) : buildFreeDrive(c.track, c.vehicle);
}
